/**
 * CanvasModulate parser: the Node2D transform and modulate, and `color`. An omitted
 * `color` falls back to white through `parseColor(undefined)`.
 */
import { parseNode2D } from '../../base/node2d/parser';
import { parseColor } from '../../../utils/colorParser';
export function parseCanvasModulate(heading, properties) {
    const base = parseNode2D(heading, properties);
    return {
        ...base,
        color: parseColor(properties.color),
    };
}
//# sourceMappingURL=parser.js.map